import React from 'react';
import MuiModal from '../MuiModal/MuiModal';
import { Button } from '../../blocks/Button';
import { Box, Typography } from '@mui/material';
import styles from './PaymentValidationErrorModal.module.scss';

export type PaymentValidationErrorModalProps = {
	open: boolean;
	onClose: () => void;
};

const PaymentValidationErrorModal: React.FC<
	PaymentValidationErrorModalProps
> = ( { open, onClose } ) => {
	return (
		<MuiModal
			muiModalProps={ {
				open,
				onClose: ( _event, _reason ) => onClose(),
				slotProps: {
					paper: {
						'data-cy': 'payment-validation-error-modal',
					},
				},
			} }
			title="Something's not right."
			controls={
				<Button
					variant='contained'
					color='primary'
					onClick={ onClose }
					data-cy='payment-validation-error-modal-button'
				>
					Got it.
				</Button>
			}
		>
			<Box className={ styles.content }>
				<Typography className={ styles.helpText }>
					Let&apos;s refresh your page and make sure you have the latest version
					of the invoice. If you have encountered this problem multiple times
					and are unable to make payment, please contact our team.
				</Typography>
			</Box>
		</MuiModal>
	);
};

export default PaymentValidationErrorModal;
